module.exports = __webpack_public_path__ + "img/B274.0d340f16.png";